import { render, staticRenderFns } from "./userHeader.vue?vue&type=template&id=3331fbab&scoped=true"
import script from "./userHeader.vue?vue&type=script&lang=js"
export * from "./userHeader.vue?vue&type=script&lang=js"
import style0 from "./userHeader.vue?vue&type=style&index=0&id=3331fbab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3331fbab",
  null
  
)

export default component.exports